export default __webpack_public_path__ + "static/media/pdf.46de4458.png";